import { BiCheckbox } from "react-icons/bi";
import { FaAngleDown } from "react-icons/fa";
// import { timeshedules } from "../../../data/businessListing/timeshedule";
import List from "../../layout/List";
import Listitem from "../../layout/Listitem";
import Button from "../../Shared/Button/Button";

const IndustryFormRow = ({ title, price }) => (
  <div className="flex justify-between border border-solid border-inputBorder py-6 pl-8 pr-20">
    <div className="font-regular flex items-center gap-x-3 font-pop text-base text-black text-opacity-50">
      <BiCheckbox />
      <p>{title}</p>
    </div>
    <div className="border border-lightGray">
      <span className="inline-block px-2 py-3 font-pop text-lg font-semibold text-primary">
        R
      </span>
      <span className="inline-block border-l border-lightGray py-3.5 px-2 font-pop text-base font-semibold text-blue">
        {price}
      </span>
    </div>
  </div>
);

const IndustryForm = () => {
  return (
    <div>
      <div>
        <div className="mt-7 flex items-center gap-x-24">
          <h3 className=" w-[225px] font-pop text-xl font-bold text-darkGreen">
            Business Name *
          </h3>
          <div className="mt-4 flex items-center">
            <input
              className="w-[623px] rounded-l-md border border-solid border-inputBorder py-5 px-6 outline-none"
              type="text"
              placeholder="Plumbers"
            />
            <div className="bg-primary py-[21px] px-6 text-white">
              <FaAngleDown className="h-6 w-6" />
            </div>
          </div>
        </div>
        <div className="mt-7 flex items-center gap-x-24">
          <h3 className=" w-[225px] font-pop text-xl font-bold text-darkGreen">
            City *
          </h3>
          <div className="mt-4 flex items-center">
            <input
              className="w-[623px] rounded-l-md border border-solid border-inputBorder py-5 px-6 outline-none"
              type="text"
              placeholder="Perth"
            />
            <div className="bg-primary py-[21px] px-6 text-white">
              <FaAngleDown className="h-6 w-6" />
            </div>
          </div>
        </div>
        <div className="mt-7 flex items-center gap-x-24">
          <h3 className=" w-[225px] font-pop text-xl font-bold text-darkGreen">
            Suburb *
          </h3>
          <div className="mt-4 flex items-center">
            <input
              className="w-[623px] rounded-l-md border border-solid border-inputBorder py-5 px-6 outline-none"
              type="text"
              placeholder="Canning vote"
            />
            <div className="bg-primary py-[21px] px-6 text-white">
              <FaAngleDown className="h-6 w-6" />
            </div>
          </div>
        </div>
        <div className="mt-7 flex items-center gap-x-24">
          <h3 className=" w-[225px] font-pop text-xl font-bold text-darkGreen">
            Mobile
          </h3>
          <div className="mt-4">
            <input
              className="w-[698px] border border-solid border-inputBorder py-5 px-6 outline-none"
              type="text"
              placeholder="035564563453"
            />
          </div>
        </div>
        <div className="mt-7 flex items-center gap-x-24">
          <h3 className=" w-[225px] font-pop text-xl font-bold text-darkGreen">
            Landline
          </h3>
          <div className="mt-4">
            <input
              className="w-[698px] border border-solid border-inputBorder py-5 px-6 outline-none"
              type="text"
              placeholder="035564563453"
            />
          </div>
        </div>
        <div className="mt-7 flex items-center gap-x-24">
          <h3 className=" w-[225px] font-pop text-xl font-bold text-darkGreen">
            Website
          </h3>
          <div className="mt-4">
            <input
              className="w-[698px] border border-solid border-inputBorder py-5 px-6 outline-none"
              type="text"
              placeholder="WWW.plumber.com"
            />
          </div>
        </div>
        <div className="mt-7 flex items-center gap-x-24">
          <h3 className=" w-[225px] font-pop text-xl font-bold text-darkGreen">
            Desription
          </h3>
          <div className="mt-4">
            <textarea
              className="h-[190px] w-[698px] border border-solid border-inputBorder py-5 px-6 outline-none"
              type="text"
              placeholder="How you can describe what you do?"
            ></textarea>
          </div>
        </div>
      </div>
      <div className="mt-10 flex gap-x-24 ">
        <h3 className="w-[225px] font-pop text-xl font-bold text-darkGreen">
          Business Hours
        </h3>
        <div className="flex w-[500px] gap-x-56">
          <List className="flex flex-col gap-y-6 font-pop text-2xl font-medium text-primary">
            <Listitem dot="dot" title="Monday" />
            <Listitem dot="dot" title="Tuesday" />
            <Listitem dot="dot" title="Wednesday" />
            <Listitem dot="dot" title="Thursday" />
            <Listitem dot="dot" title="Friday" />
            <Listitem dot="dot" title="Saturday" />
            <Listitem dot="dot" title="Sunday" />
          </List>
          <List className=" flex flex-col gap-y-7 font-pop text-xl font-medium text-secondary">
            <Listitem className="w-[182px] " time="8:00 AM - 5:00 PM" />
            <Listitem time="8:00 AM - 5:00 PM" />
            <Listitem time="8:00 AM - 5:00 PM" />
            <Listitem time="8:00 AM - 5:00 PM" />
            <Listitem time="8:00 AM - 5:00 PM" />
            <Listitem time="8:00 AM - 5:00 PM" />
            <Listitem time="8:00 AM - 5:00 PM" />
          </List>
        </div>
        <div className="font-regular flex flex-col gap-y-8 font-pop text-base text-darkGreen">
          <button className="border-b border-solid border-darkGreen">
            Edit
          </button>
          <button className="border-b border-solid border-darkGreen">
            Edit
          </button>
          <button className="border-b border-solid border-darkGreen">
            Edit
          </button>
          <button className="border-b border-solid border-darkGreen">
            Edit
          </button>
          <button className="border-b border-solid border-darkGreen">
            Edit
          </button>
          <button className="border-b border-solid border-darkGreen">
            Edit
          </button>
          <button className="border-b border-solid border-darkGreen">
            Edit
          </button>
        </div>
      </div>
      <div>
        <div className="mt-7 flex items-center gap-x-24">
          <h3 className=" w-[225px] font-pop text-xl font-bold text-darkGreen">
            Payment Methods
          </h3>
          <div className="mt-4">
            <input
              className="w-[698px] border border-solid border-inputBorder py-5 px-6 outline-none"
              type="text"
              placeholder="Eft Cash No Ewallet"
            />
          </div>
        </div>
        <div className="mt-7 flex items-center gap-x-24">
          <h3 className=" w-[225px] font-pop text-xl font-bold text-darkGreen">
            Address
          </h3>
          <div className="mt-4">
            <input
              className="w-[698px] border border-solid border-inputBorder py-5 px-6 outline-none"
              type="text"
              placeholder="035564563453"
            />
          </div>
        </div>
        <div className="mt-7 flex items-center gap-x-24">
          <h3 className=" w-[225px] font-pop text-xl font-bold text-darkGreen">
            Tags
          </h3>
          <div className="mt-4">
            <input
              className="w-[698px] border border-solid border-inputBorder py-5 px-6 outline-none"
              type="text"
              placeholder="Plumbing,Plumbing Training"
            />
          </div>
        </div>
      </div>
      <div className="mt-12 flex flex-col items-end">
        <div className="w-[698px]">
          <div className="flex justify-between border border-solid border-inputBorder py-6 px-24">
            <p className=" font-pop text-base font-medium">Period</p>
            <p className="font-pop text-base font-medium">Price</p>
          </div>
          <IndustryFormRow
            title={"Create Business Listing for 6 Months"}
            price={250}
          />
          <IndustryFormRow
            title={"Create Business Listing for 12 Months"}
            price={150}
          />
          <IndustryFormRow title={"Add to Gallery Slider"} price={50} />
        </div>
        <div className="mt-11 mb-[70px] flex gap-5">
          <Button
            text={"Preview Listing"}
            variant={"primary"}
            className="!w-auto !px-12 !py-4 !text-2xl"
          />
          <Button
            text={"Agree and Submit"}
            variant={"secondary"}
            className="!w-auto !px-12 !py-4 !text-2xl"
          />
        </div>
      </div>
    </div>
  );
};

export default IndustryForm;
